import { z } from 'zod';
import { UuidSchema } from './common.js';
const NonEmptyStringSchema = z.string().trim().min(1);
export const TranscriptChunkInputSchema = z
    .object({
    ordinal: z.number().multipleOf(1).nonnegative(),
    turnStartIndex: z.number().multipleOf(1).nonnegative(),
    turnEndIndex: z.number().multipleOf(1).nonnegative(),
    content: NonEmptyStringSchema,
    embedding: z.array(z.number()).min(1),
})
    .strict()
    .refine((value) => value.turnEndIndex >= value.turnStartIndex, {
    message: 'turnEndIndex must be greater than or equal to turnStartIndex',
    path: ['turnEndIndex'],
});
export const ReplaceTranscriptChunksRequestSchema = z
    .object({
    organizationId: UuidSchema,
    chunks: z.array(TranscriptChunkInputSchema).max(500),
})
    .strict();
export const TranscriptChunkStatsResponseSchema = z
    .object({
    sessionId: UuidSchema,
    organizationId: UuidSchema,
    chunkCount: z.number().multipleOf(1).nonnegative(),
})
    .strict();
export const RetrievedTranscriptChunkSchema = z
    .object({
    sessionId: UuidSchema,
    projectId: UuidSchema,
    organizationId: UuidSchema,
    participantId: z.string().nullable(),
    chunkId: UuidSchema,
    ordinal: z.number().multipleOf(1).nonnegative(),
    turnStartIndex: z.number().multipleOf(1).nonnegative(),
    turnEndIndex: z.number().multipleOf(1).nonnegative(),
    content: NonEmptyStringSchema,
    score: z.number(),
})
    .strict();
export const RetrieveTranscriptChunksRequestSchema = z
    .object({
    organizationId: UuidSchema,
    projectId: UuidSchema,
    query: NonEmptyStringSchema,
    queryEmbedding: z.array(z.number()).optional(),
    limit: z.number().multipleOf(1).positive().max(100).prefault(24),
})
    .strict();
export const RetrieveTranscriptChunksResponseSchema = z
    .object({
    projectId: UuidSchema,
    organizationId: UuidSchema,
    items: z.array(RetrievedTranscriptChunkSchema),
})
    .strict();
//# sourceMappingURL=TranscriptChunks.js.map